import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../../../../components/Modal/Modal";

const RestartLearnerProgressModal = ({
  open,
  onClose,
  onSubmit,
  isLoading
}) => {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [restartLearners, setRestartLearners] = useState(false);

  const handleSubmit = restart => {
    setRestartLearners(restart);
    setIsSubmitted(true);
    if (!isLoading) {
      onSubmit(restart);
    }
  };

  useEffect(() => {
    if (!open) {
      setIsSubmitted(false);
    }
  }, [open]);

  useEffect(() => {
    if (open && isSubmitted && !isLoading) {
      onSubmit(restartLearners);
    }
  }, [isLoading]);

  return (
    <Modal
      scrollable
      disableEnforceFocus
      showCloseIcon
      maxWidth="sm"
      fullWidth
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t(`preDeployNoticeModal.title`)}
        </Typography>
      }
      dialogContent={
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            mb={5.5}
            flexDirection={{ xs: "column", sm: "row" }}
            flexWrap="wrap"
          >
            <Typography variant="body1">
              {t(`preDeployNoticeModal.description`)}
            </Typography>
          </Box>
        </>
      }
      dialogActions={
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit(true)}
            disabled={isSubmitted && isLoading}
            data-qa="restart-learner-progress-yes-btn"
          >
            {t("preDeployNoticeModal.yesBtn")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit(false)}
            disabled={isSubmitted && isLoading}
            data-qa="restart-learner-progress-no-btn"
          >
            {t("preDeployNoticeModal.noBtn")}
          </Button>
          <Button
            color="primary"
            onClick={onClose}
            disabled={isSubmitted && isLoading}
            data-qa="restart-learner-progress-cancel-btn"
          >
            {t("preDeployNoticeModal.cancelBtn")}
          </Button>
        </>
      }
      open={open}
      onClose={onClose}
      data-qa="restart-learner-progress-modal"
    ></Modal>
  );
};

export default RestartLearnerProgressModal;

RestartLearnerProgressModal.propTypes = {
  /**
   * True if we should show the modal in a loading state after the learner has selected
   * yes or no because we are still loading the info for the next view.
   * If true, the onSubmit method will only be called after isLoading becomes false.
   */
  isLoading: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  /**
   * Called if the user selects yes or no to restart learner progress
   */
  onSubmit: PropTypes.func
};
